import { type CopyBundle } from './types'

export const mockCopyBundle: CopyBundle = {
  'longer.static.copy.key': {
    localized_messages: {
      en: { type: 'SIMPLE', simple: { content: 'I like red' } },
      'en-GB': { type: 'SIMPLE', simple: { content: 'I like white' } },
      'en-US': { type: 'SIMPLE', simple: { content: 'I like blue' } },
      'en-IE': { type: 'SIMPLE', simple: { content: 'I like green' } },
      'es-ES': {
        type: 'SIMPLE',
        simple: { content: 'Mi gusta el color blanco' },
      },
    },
  },
  'static.copy.key': {
    localized_messages: {
      en: { type: 'SIMPLE', simple: { content: 'I like red' } },
      'en-GB': { type: 'SIMPLE', simple: { content: 'I like white' } },
      'en-US': { type: 'SIMPLE', simple: { content: 'I like blue' } },
      'en-IE': { type: 'SIMPLE', simple: { content: 'I like green' } },
      'es-ES': {
        type: 'SIMPLE',
        simple: { content: 'Mi gusta el color blanco' },
      },
    },
  },
  'my.first.key': {
    localized_messages: {
      en: {
        type: 'SIMPLE',
        simple: { content: 'My favourite colour is {{ colour }}' },
      },
      'en-GB': {
        type: 'SIMPLE',
        simple: { content: 'My favourite colour is {{ colour }}' },
      },
      'en-US': {
        type: 'SIMPLE',
        simple: { content: 'My favorite color is {{ colour }}' },
      },
      'en-IE': {
        type: 'SIMPLE',
        simple: { content: 'My favourite colour is {{ colour }}' },
      },
      'es-ES': {
        type: 'SIMPLE',
        simple: { content: 'Mi color favorito es el {{ colour }}' },
      },
    },
  },
  'key.with.cardinal': {
    localized_messages: {
      en: {
        type: 'PLURAL_FORMS',
        plural_forms: {
          one: {
            content: 'You have made {{ numPayments}} payment',
          },
          other: 'You have made {{ numPayments }} payments',
        },
      },
      'en-GB': {
        type: 'PLURAL_FORMS',
        plural_forms: {
          one: {
            content: 'You have made {{ numPayments}} payment',
          },
          other: 'You have made {{ numPayments }} payments',
        },
      },
      'en-US': {
        type: 'PLURAL_FORMS',
        plural_forms: {
          one: {
            content: 'You have made {{ numPayments}} payment',
          },
          other: 'You have made {{ numPayments }} payments',
        },
      },
      'en-IE': {
        type: 'PLURAL_FORMS',
        plural_forms: {
          one: {
            content: 'You have made {{ numPayments}} payment',
          },
          other: 'You have made {{ numPayments }} payments',
        },
      },
      'es-ES': {
        type: 'PLURAL_FORMS',
        plural_forms: {
          one: {
            content: 'Has realizado {{ numPayments }} pago',
          },
          other: 'Has realizado {{ numPayments }} pagos',
        },
      },
    },
  },
  'key.with.ordinal': {
    localized_messages: {
      en: {
        type: 'PLURAL_FORMS',
        plural_forms: {
          one: { content: "I'm the {{rank}}st one" },
          two: { content: "I'm the {{rank}}nd one" },
          few: { content: "I'm the {{rank}}rd one" },
          other: "I'm the {{rank}}th one",
        },
      },
      'en-GB': {
        type: 'PLURAL_FORMS',
        plural_forms: {
          one: { content: "I'm the {{rank}}st one" },
          two: { content: "I'm the {{rank}}nd one" },
          few: { content: "I'm the {{rank}}rd one" },
          other: "I'm the {{rank}}th one",
        },
      },
      'es-ES': {
        type: 'PLURAL_FORMS',
        plural_forms: {
          other: 'Soy el {{rank}}ᵒ',
        },
      },
    },
  },
}
